import React, { useEffect, useState } from 'react';
import { getAllTrips } from '@services/trips.service';
import { QueryRequestHelper } from '@common/query-request-helper';
import { getValue } from '@utils/lodash';
import Loader from '@components/common/Loader';
import TripsSvgComponent from "@assets/svg-components/dashboard/trips";
import { getColorStyle, getSingleColor } from "@common/color";
import { convertCurrentDate } from "@common/date-helpers";
import { formatAmount, formatText } from "@common/text-helpers";
import ProfileCircle from "@components/ProfileCircle";
import { useNavigate } from 'react-router-dom';
import SkeletonTable from "@components/common/Skeleton/skeleton-table";
import './styles.scss';

const PendingTripsList = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit] = useState(10);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    let payload: any = {
      page_no: 1,
      page_size: limit,
      travel_mode: "flight",
      filter_type: "my_approval",
      is_pending_my_approval: true
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getAllTrips(queryRequest);
      if (resp) {
        setList(getValue(resp, `data.trip`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleNavigate = (id: string) => {
    const queryRequest = QueryRequestHelper({});
    navigate(`/client/approval/trips/detail/${id}?${queryRequest}`);
  };

  if (isLoading) {
    return <SkeletonTable />;
  }

  return (
    <>
    <div className="table-responsive-container">
      <div className="table-wrapper">
        <table className="datatable_table">
          <thead className="datatable_table_thead">
            <tr>
              <th className="datatable_table_th" style={{ width: "40px" }}></th>
              <th className="datatable_table_th" style={{ width: "120px" }}>
                <h6 className="">Trip No</h6>
              </th>
              <th className="datatable_table_th" style={{ width: "160px" }}>
                <h6 className="">Trip Details</h6>
                <p className="small_text">Travel Type</p>
              </th>
              <th className="datatable_table_th" style={{ width: "150px" }}>
                <h6 className="">Total Amount</h6>
              </th>
              <th className="datatable_table_th" style={{ width: "120px" }}>
                <h6 className="">Submitted On</h6>
              </th>
              <th className="datatable_table_th" style={{ width: "280px" }}>
                <h6 className="">Submitted By</h6>
              </th>
              <th className="datatable_table_th" style={{ width: "120px" }}>
                <h6 className="">Status</h6>
              </th>
            </tr>
          </thead>
          <tbody className="datatable_table_tbody">
            {list.length > 0 ? (
              list.map((item: any, index: number) => (
                <tr key={index} className="datatable_table_tr">
                  <td className="datatable_table_td" style={{ width: "70px" }}>
                    <TripsSvgComponent
                      color={getSingleColor(getValue(item, `approval_status`, ""))}
                      size={20}
                    />
                  </td>
                  <td
                    className="datatable_table_td align-items-center"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className="color_primary">
                          {getValue(item, `trip_id`, "")}
                        </h6>
                      </div>
                    </div>
                  </td>
                  <td
                    className="datatable_table_td align-items-center"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className="">{getValue(item, `trip_name`, "")}</h6>
                        <p className="small_text">
                          {formatText(getValue(item, `travel_type`, ""))}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    {parseFloat(getValue(item, `total`, "")) ? (
                      <h6 className={parseInt(getValue(item, `total`, 0)) < 0 ? "color_danger" : ""}>
                        {getValue(item, `claimed_currency_symbol`, "")} {formatAmount(getValue(item, `total`, ""))}
                      </h6>
                    ) : (
                      <p className="ms-4">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    {convertCurrentDate(getValue(item, `submitted_at`, ""))}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    {getValue(item, `created_by.email`, "") ? (
                      <div className="d-flex align-items-center">
                        <ProfileCircle
                          name="created_by"
                          item={item}
                          value={getValue(item, `created_by.first_name`, "")}
                        />
                        <div>
                          <h6 className="">
                            {getValue(item, `created_by.first_name`, "")}{" "}
                            {getValue(item, `created_by.middle_name`, "")}{" "}
                            {getValue(item, `created_by.last_name`, "")}
                          </h6>
                          <p className="small_text">
                            {getValue(item, `created_by.email`, "")}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center ms-5">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() => handleNavigate(getValue(item, `id`, ""))}
                  >
                    <h6
                      className=""
                      style={getColorStyle(`${getValue(item, `approval_status`, "")}`)}
                    >
                      {formatText(getValue(item, `approval_status`, ""))}
                    </h6>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  No pending trips found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>

    <div className="d-flex justify-content-end">
      <button className='btn btn-primary p-2 px-4 mt-3' onClick={() => navigate('/client/approval/trips')}>View All</button>
    </div>
    </>
  );
};

export default PendingTripsList; 